import React from 'react';

import { FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import { swiperItemPropTypes } from '@ecp/common/src/components/swiper/component/SwiperItem';

import GoodCard from './GoodCard';

const GoodCardCarouselItem = ({ item, itemProps, handleCartPopupSuccess }) => (
  <FlexBoxColumn width="130px">
    <GoodCard
      type={itemProps.type}
      showRelated={itemProps.showRelated}
      {...item}
      handleCartPopupSuccess={handleCartPopupSuccess}
    />
  </FlexBoxColumn>
);

GoodCardCarouselItem.propTypes = swiperItemPropTypes;

export default GoodCardCarouselItem;
